import * as types from './mutation-types'


export default {
  changeAppLoadingStatus ({ commit }, status = false) {
    commit('changeAppLoadingStatus', status)
  }
}